import React from 'react'
import PropTypes from 'prop-types'
import Swiper from 'react-id-swiper'

import Item from './Item'

const Items = ({ items, containerClass }) => {
  const swiperProps = {
    containerClass: `swiper-container w-100 ${containerClass}`,
    freeMode: true,
    slidesPerView: 'auto',
    touchRatio: 0.4,
    mousewheel: true,
  }

  return (
    <Swiper {...swiperProps}>
      {items.map(
        (item, i) =>
          item && (
            <div
              style={{ width: 226 }}
              key={i}
              className={`swiper-slide w-auto mb5 ${i === 0 ? 'ml4' : ''}
              ${i === item.length - 1 ? 'mr4' : ''}`}
            >
              <Item {...item} />
            </div>
          )
      )}
    </Swiper>
  )
}

Items.defaultProps = {
  containerClass: '',
}

Items.propTypes = {
  containerClass: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      imageSrc: PropTypes.string.isRequired,
      totalPrice: PropTypes.number.isRequired,
      amount: PropTypes.number,
      showStartingAt: PropTypes.bool,
      skuId: PropTypes.string,
      productId: PropTypes.string,
    })
  ),
}

export default Items
